export default __webpack_public_path__ + "static/media/inactiveGridView.e00e7599.svg";